import {useFlagVariation} from '@customink/signalmizely-react';

// Running A/B tests in Catalog's React APP
export const VISUAL_FILTERS_TEST = 'pc_visual_filters_v0';

export const useFeatureFlag = (flagName) => {
  // {error, isLoading, variation} tuple
  return useFlagVariation(flagName);
};

export const featureFlagNotEligible = () => {
  return {error: null, isLoading: false, variation: null};
};
